import React, { useState } from 'react';

const Row = ({row}) => {
  const [focused, setFocused] = useState(false);

  return (
    <tr style={{borderBottom: '1px solid #222',
                backgroundColor: focused ? '#333' : 'transparent',
               }}>
      {row.map((element, index) => {
        return <td style={{
                     textAlign: 'center',
                     overflow: 'hidden',
                     whiteSpace: 'nowrap',
                     padding: '20px',
                   }}
                   key={index}
                   onMouseEnter={() => setFocused(true)}
                   onMouseLeave={() => setFocused(false)}>
                 <div style={{overflow: 'auto',
                              paddingBottom: '10px',
                             }}>
                   {element}
                 </div>
               </td>;
      })}
    </tr>
  );
}

const Table = ({headers, contents, proportions}) => {
  const total = proportions.reduce((sum, p) => sum + p, 0);

  return (
    <table
      style={{
        borderCollapse: 'collapse',
        width: '100%',
        tableLayout: 'fixed',
      }}>
      <thead>
        <tr>
          {headers.map((element, index) => {
            return <th style={{
                         width: (proportions[index] / total) * 100 + '%',
                         border: '1px solid black',
                         textAlign: 'center',
                         overflow: 'hidden',
                         whiteSpace: 'nowrap',
                         backgroundColor: '#333',
                         padding: '15px',
                       }}
                       key={index}>
                     {element}
                   </th>;
          })}
        </tr>
      </thead>
      <tbody>
        {contents.map((row, index) => {
          return <Row row={row} key={index} />
        })}
      </tbody>
    </table>
  );
}

export default Table;
